import type { CelebrationItem, CelebrationPresentationMeta, CelebrationTier } from './celebration.types';

type CreatorCelebrationPolicyEntry = {
  tier: CelebrationTier;
  whyItMatters: string;
  primaryCtaLabel: string;
  primaryCtaHref?: string;
  secondaryCtaLabel?: string;
  eyebrow?: string;
};

export const CREATOR_CELEBRATION_POLICY: Record<string, CreatorCelebrationPolicyEntry> = {
  'creator-onboarding-complete': {
    tier: 3,
    eyebrow: 'Studio live',
    whyItMatters: 'Your storefront and referral links are ready — start sharing to earn commissions.',
    primaryCtaLabel: 'Copy storefront link',
    primaryCtaHref: '/creator/links',
    secondaryCtaLabel: 'Explore dashboard',
  },
  'creator-first-referral-click': {
    tier: 1,
    eyebrow: 'First click',
    whyItMatters: 'Someone followed your link — keep promoting to turn clicks into commissions.',
    primaryCtaLabel: 'View analytics',
    primaryCtaHref: '/creator/analytics',
  },
  'creator-first-commission': {
    tier: 3,
    eyebrow: 'First commission',
    whyItMatters: 'You earned from a referred sale — this is how creator revenue compounds.',
    primaryCtaLabel: 'View earnings',
    primaryCtaHref: '/creator/earnings',
  },
  'creator-tier-upgrade': {
    tier: 2,
    eyebrow: 'Tier upgrade',
    whyItMatters: 'Your commission rate increased — promote your best-converting products.',
    primaryCtaLabel: 'Browse products to promote',
    primaryCtaHref: '/creator/products',
  },
};

const CREATOR_DEFAULT_POLICY: CreatorCelebrationPolicyEntry = {
  tier: 2,
  whyItMatters: 'You unlocked a creator milestone — momentum builds with consistent promotion.',
  primaryCtaLabel: 'Open creator dashboard',
  primaryCtaHref: '/creator/dashboard',
};

export function resolveCreatorCelebrationMeta(item: CelebrationItem): CelebrationPresentationMeta {
  const policy = CREATOR_CELEBRATION_POLICY[item.code] ?? CREATOR_CELEBRATION_POLICY[item.id] ?? CREATOR_DEFAULT_POLICY;
  return {
    tier: policy.tier,
    eyebrow:
      policy.eyebrow ??
      (item.id === 'creator-onboarding-complete' ? 'Setup complete' : 'Milestone reached'),
    whyItMatters: policy.whyItMatters,
    primaryCtaLabel: policy.primaryCtaLabel,
    primaryCtaHref: policy.primaryCtaHref ?? item.href ?? '/creator/dashboard',
    secondaryCtaLabel: policy.secondaryCtaLabel ?? 'Continue',
  };
}
